<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
/* eslint-disable */

const app = {
    name: 'app',

    data: function() {
        return {
            currentUID: null,
        }
    },

    mounted: function() {

    }
};

export default app;


</script>

<style lang="scss">
body {
    height: 100%;
}
#app {
    height: 100%;
    min-height: 100%;
    form {
        width: 100%;
        text-align: center;
    }
    .md-sidenav {
        .md-backdrop {
            position: fixed;
        }
        .md-sidenav-content {
            position: fixed;
            form {
                text-align: left;
            }
        }
    }
}
.container {
    height: 100%;
    min-height: 100%;
}
.flex-container {
    height: 100%;
    min-height: 100%;
    display: flex;
    h1,h2 {
        text-align: center;
        width: 100%;
    }
}


// clean UI theme
.md-theme-default, .md-theme-show-mode {
    &.md-button {
        &:not([disabled]) {
            &.md-raised {
                background-color: #5ecfdf !important;
                color: #000 !important;
                &:hover {
                    background-color: lighten(#5ecfdf, 5%) !important;
                }
            }
        }
    }
    .md-ink-ripple {
        color: #5ecfdf !important;
    }
    &.md-checkbox.md-checked {
        .md-checkbox-container {
            background-color: #5ecfdf !important;
            border-color: #5ecfdf !important;
        }
    }
}

.md-theme-show-mode {
    .md-input-container {
        // &.md-has-value {
        // &.md-input-required {
        // &.md-input-focused {
            input, textarea, .md-input, label {
                color: rgba(255, 255, 255, 0.87) !important;
            }
        &:after {
            background-color: rgba(255, 255, 255, 0.12) !important;
        }
    }
}

.md-toolbar {
    &.main-toolbar {
        background-color: #0d2744 !important;
    }
}

.layout-separator {
    margin-bottom: 35px;
}

.md-avatar {
    img {
        object-fit: cover;
    }
}

.md-theme-show-mode {
    .md-list-text-container {
        span {
            color: rgba(255, 255, 255, 0.87) !important;
        }
    }
    .md-list-item .md-icon {
        color: rgba(255, 255, 255, 0.87);
    }

    &.pendingCollaboratorList {
        .md-list-text-container {
            span {
                color: rgba(0, 0, 0, 0.87) !important;
            }
        }
        .md-list-item .md-icon {
            color: rgba(0, 0, 0, 0.54);
        }
        .md-button {
            color: rgba(0, 0, 0, 0.54);
        }
    }
    .collaborator-text-container {
        span {
            color: rgba(255, 255, 255, 0.87) !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// App.vue?c57a7286